"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function PreferencesSection({ title, subtitle, onClick, className, children, }) {
    const Component = ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'PreferencesSection_Container', children: [title && (0, jsx_runtime_1.jsx)(SectionTitle, { "data-e2e": 'PreferencesSection_SectionTitle', children: title }), subtitle && (0, jsx_runtime_1.jsx)(SectionSubtitle, { "data-e2e": 'PreferencesSection_SectionSubtitle', children: subtitle }), children] }));
    if (onClick) {
        return (0, jsx_runtime_1.jsx)(A11yContainer, { onClick: onClick, "data-e2e": 'PreferencesSection_A11yContainer', children: Component });
    }
    return Component;
}
exports.PreferencesSection = PreferencesSection;
const A11yContainer = (0, ui_1.withA11y)(styled_components_1.default.button `
  width: 100%;
  padding: 0;

  background: none;
  border: none;
  outline-offset: -10px;
  cursor: pointer;
`);
const Container = styled_components_1.default.div `
  padding: 15px 0;

  &:first-child {
    padding-top: 20px;
  }

  user-select: none;
`;
const SectionTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 15px;

  color: ${({ theme }) => theme.designSystem.text};
  font-size: 16px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    display: block;
  `)}
`;
const SectionSubtitle = styled_components_1.default.div `
  margin-bottom: 20px;

  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
  text-align: left;
`;
